import DefaultStorageProvider from './types/DefaultStorageProvider.js';

class Storage {
  constructor(options) {
    var _a, _b;
    this.namespace = (_a = options === null || options === void 0 ? void 0 : options.namespace) !== null && _a !== void 0 ? _a : 'wtgStorage';
    this.provider = (_b = options === null || options === void 0 ? void 0 : options.storageProvider) !== null && _b !== void 0 ? _b : new DefaultStorageProvider();
  }
  loadUserSetting(key) {
    return this.provider.loadUserSetting(this.namespace, key);
  }
  saveUserSetting(key, value) {
    this.provider.saveUserSetting(this.namespace, key, value);
  }
  loadUserJSON(key) {
    const storageValue = this.loadUserSetting(key);
    return storageValue ? JSON.parse(storageValue) : null;
  }
  loadUserBoolean(key) {
    const storageValue = this.loadUserJSON(key);
    return storageValue || storageValue === false ? Boolean(storageValue) : null;
  }
  loadUserString(key) {
    const storageValue = this.loadUserSetting(key);
    return storageValue ? storageValue.toString() : null;
  }
  removeUserSetting(key) {
    this.provider.removeUserSetting(this.namespace, key);
  }
}

export { Storage as default };
